import { createFileRoute, redirect } from '@tanstack/react-router';

/** "สะสมแต้ม" in the menu: opens the loyalty tab of the customer settings, which stays where it was. */
export const Route = createFileRoute('/_app/loyalty')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/customers', search: { tab: 'loyalty' }, replace: true });
  },
});
